import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Shared tab bar for the Cash Flow section, same pattern as ExpenseTabs.js -
// one sidebar entry ("Cash Flow"), switch between Forecast/Receivables/
// Materials/Site/Accounts once inside the section.
const TABS = [
  { to: '/cashflow', label: 'Forecast' },
  { to: '/cashflow/receivables', label: 'Receivables' },
  { to: '/cashflow/materials', label: 'Materials' },
  { to: '/cashflow/site', label: 'Site' },
  { to: '/cashflow/accounts', label: 'Accounts' },
];

const CashFlowTabs = () => {
  const location = useLocation();
  return (
    <div className="glass-widget flex gap-1 p-1.5 mb-6 w-fit flex-wrap">
      {TABS.map((tab) => {
        const active = location.pathname === tab.to;
        return (
          <Link
            key={tab.to}
            to={tab.to}
            className={`text-sm px-4 py-1.5 rounded-xl font-medium transition-colors ${
              active ? 'bg-white/90 text-komal-blue' : 'text-white/85 hover:bg-white/10'
            }`}
          >
            {tab.label}
          </Link>
        );
      })}
    </div>
  );
};

export default CashFlowTabs;
